import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyListPagingComponent } from './list-paging.component';
import { SkyPagingModule } from '../paging';


export class SkyListPagingModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyListPagingComponent
  ],
  imports: [
    CommonModule,
    SkyPagingModule
  ],
  exports: [
    SkyListPagingComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
